import { useTranslation } from "react-i18next";
import Languages from "../../../src/assets/images/icons/Languages.svg";

function LanguageSwitcher({className=""}:{className?:string}) {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language?.slice(0, 2) === "en" ? "ar" : "en";
    i18n.changeLanguage(newLanguage);
    document.documentElement.lang = newLanguage;
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`w-fit h-fit ${i18n.language.slice(0, 2) === "en" ? "arabic" : ""} main_warper ${className}`}
    >
      <img src={Languages} alt="Languages" className="h-5 w-5" />
      <div className="font-[500]">
        {i18n.language.slice(0, 2) === "en" ? "العربية" : "English"}
      </div>
    </button>
  );
}

export default LanguageSwitcher;
